import theme from "@config/theme";
import { OptimizedImage } from "@components/OptimizedImage";
import Accelerator from "./Accelerator";
import AcceleratorLink from "./AcceleratorLink";
import Tags from "../Tags";

type ProjectListProps = {
  projects: Accelerator[];
};

const ProjectList = ({ projects }: ProjectListProps) => (
  <>
    <ul className="projects-container">
      {projects.map((project) => (
        <li key={project.id}>
          <AcceleratorLink projectName={project.name}>
            <div className="project">
              <div className="project-logo">
                <OptimizedImage
                  src={`/images/accelerators/app-icons/${project.id}-icon.svg`}
                  alt=""
                />
              </div>
              <div>
                <h3>{project.name}</h3>
                <div>
                  {project.shortDescription}
                  <div className="project-cta">Learn more</div>
                </div>
                <Tags tags={project.tags} />
              </div>
            </div>
          </AcceleratorLink>
        </li>
      ))}
    </ul>
    <style jsx>
      {`
        li {
          // remove bullet points
          list-style-type: none;
        }

        .projects-container {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 3rem;
          padding-left: 0;
        }

        .project {
          display: flex;
        }

        .project > div:first-child {
          width: 75px;
          flex-shrink: 0;
        }

        h3 {
          margin-top: 0;
        }

        .project-cta {
          display: none;
        }

        @media only screen and (max-width: ${theme.breakpoints.md}px) {
          .projects-container {
            grid-template-columns: 1fr;
          }

          .project-cta {
            display: block;
            margin-top: 0;
            font-weight: 600;
            color: ${theme.colors.ultramarineTint};
          }
        }
      `}
    </style>
  </>
);

export default ProjectList;
